

import MessgaeFrom from 'components/modules/auth/MessgaeFrom';
import AuthCardLayout from 'layouts/AuthCardLayout';

const NotificationMessage = () => {
  return (
    <AuthCardLayout logo={false}>
      <MessgaeFrom />
    </AuthCardLayout>
  );
};

export default NotificationMessage;
